import { useMutation } from '@apollo/client';
// Api
import { COMPLETE_TIKTOK_INTEGRATION_AUTH } from 'api/auth/mutations';
import { CONNECTED_SOCIAL_ACCOUNTS } from 'api/auth/queries';
// Api Types
import {
  CompleteTiktokIntegrationAuth,
  CompleteTiktokIntegrationAuthVariables,
} from 'api/auth/types/CompleteTiktokIntegrationAuth';

export const useCompleteTiktokIntegrationAuth = () => {
  return useMutation<
    CompleteTiktokIntegrationAuth,
    CompleteTiktokIntegrationAuthVariables
  >(COMPLETE_TIKTOK_INTEGRATION_AUTH, {
    refetchQueries: [{ query: CONNECTED_SOCIAL_ACCOUNTS }],
    awaitRefetchQueries: true,
  });
};
